const menuConfig = [
  // {
  //   name: 'alerts',
  //   path: '/alerts',
  //   options: [
  //     {
  //       name: 'alertTemplateSetup',
  //       path: '/alert-template-setup',
  //     },
  //   ],
  // },
  // {
  //   name: 'integration',
  //   path: '/integration',
  //   options: [
  //     {
  //       name: 'catalina',
  //       path: '/catalina',
  //     },
  //   ],
  // },

  // {
  //   name: 'technical',
  //   path: '/technical',
  //   options: [
  //     {
  //       name: 'keyboardProgramming',
  //       path: '/keyboard-programming',
  //     },
  //   ],
  // },
];

export default menuConfig;
